export default __webpack_public_path__ + "static/media/verified-issuer-mark.920a7648.svg";